import { render, staticRenderFns } from "./IaCompanyInstructions.vue?vue&type=template&id=b1293268&scoped=true&"
import script from "./IaCompanyInstructions.vue?vue&type=script&lang=js&"
export * from "./IaCompanyInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1293268",
  null
  
)

export default component.exports